var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "vacancy-cards-container" },
        [
          _vm._l(_vm.filtered, function(vacancy, index) {
            return _c("div", { key: index, staticClass: "vacancy-card" }, [
              _c("h4", [_vm._v(_vm._s(vacancy.title))]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Location:")]),
                _vm._v(
                  " " + _vm._s(vacancy.region ? vacancy.region : "Unknown")
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Salary:")]),
                _vm._v(" " + _vm._s(vacancy.salary ? vacancy.salary : "N/A"))
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button button--type-primary",
                  attrs: { href: vacancy.permalink }
                },
                [_vm._v("View vacancy")]
              )
            ])
          }),
          _vm._v(" "),
          _vm.filtered.length === 0
            ? _c("div", { staticClass: "no-vacancies" }, [
                _c("h4", [_vm._v("No vacancies found")])
              ])
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "vacancy-list__title" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v("\n        Latest vacancies\n      ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }